module.exports = __webpack_public_path__ + "img/vue2-corpsarr_vert.a3d80a81.png";